/**
 * dg-free-shipping-fx.js  v7.1 — Zone-aware free shipping bar
 *
 * Zones détectées par code postal COMPLET (6 caractères) :
 *   La Tuque    → tous les G9X SAUF exceptions ci-dessous → seuil 100$ (10000 cents)
 *   Région      → G9X0A7, G9X3N7, G9X3N8 uniquement      → seuil 250$ (25000 cents)
 *   Hors zone   → tout autre code postal
 *
 * Lookup stocké en localStorage sous 'dg_postal_zone'
 * Format: { postal: 'G9X1E4', zone: 'latuque'|'region'|'hors', threshold: 10000|25000 }
 */
(function () {
    'use strict';

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var LS_KEY = 'dg_postal_zone';

    /* ── Codes G9X qui sont région (250$) — La Bostonnais, La Croche, Lac-à-Beauce ── */
    var G9X_REGION_EXCEPTIONS = {
        'G9X0A7': true,  // La Bostonnais
        'G9X3N7': true,  // La Croche
        'G9X3N8': true   // Lac-à-Beauce
    };

    /* ── Zone configuration ── */
    var ZONES = {
        latuque: {
            threshold: 10000,   // 100$
            label: '100$',
            name: 'La Tuque'
        },
        region: {
            threshold: 25000,   // 250$
            label: '250$',
            name: 'ta région'
        },
        wemontaci: {
            threshold: 25000,   // 250$ (même seuil que région)
            label: '250$',
            name: 'Wemotaci'
        }
    };

    /* ── State ── */
    var THRESHOLD = 10000; // default until postal known
    var currentZone = null;
    var hasCelebratedFree = false;
    var prevPct = 0;
    var _ddInjectionObserver = null; // tracks the Ding Doong body observer — one at a time

    /* ── Money formatter ── */
    function fmt(cents) {
        cents = parseInt(cents, 10) || 0;
        return '$' + (cents / 100).toFixed(2);
    }

    /* ── SVGs ── */
    var truckSvg = '<svg style="width:16px;height:16px;vertical-align:middle;margin-right:5px;color:#fff;filter:drop-shadow(0 1px 3px rgba(0,0,0,0.5))" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"/><path d="M3 9h4"/></svg>';
    var checkSvg = '<svg style="width:18px;height:18px;vertical-align:middle;margin-right:6px;color:#fff;filter:drop-shadow(0 0 4px rgba(255,255,255,0.5))" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l5 5l10 -10"/></svg>';

    /* ── Determine zone from postal code (full 6-char lookup) ── */
    function detectZone(rawPostal) {
        if (!rawPostal) return null;
        var clean = rawPostal.replace(/\s/g, '').toUpperCase().substring(0, 6);
        
        // Exiger un code postal complet (6 caractères)
        if (clean.length < 6) {
            return { key: 'invalid_length', zone: null, postal: clean };
        }
        
        var prefix3 = clean.substring(0, 3);

        // G0X → Wemotaci (250$ free shipping)
        if (prefix3 === 'G0X') {
            if (clean === 'G0X3R0') {
                return { key: 'wemontaci', zone: ZONES.wemontaci, postal: clean };
            }
            return { key: 'hors', zone: null, postal: clean };
        }

        // Must start with G9X — everything else is hors zone
        if (prefix3 !== 'G9X') {
            return { key: 'hors', zone: null, postal: clean };
        }

        // G9X exceptions → région (250$)
        if (G9X_REGION_EXCEPTIONS[clean]) {
            return { key: 'region', zone: ZONES.region, postal: clean };
        }

        // All other G9X → La Tuque (100$)
        return { key: 'latuque', zone: ZONES.latuque, postal: clean };
    }

    /* ── Apply zone & update threshold ── */
    function applyZone(detection) {
        var msgEl = document.getElementById('dg-fs-postal-msg');
        var formEl = document.getElementById('dg-fs-postal-form');

        if (!detection || detection.key === 'hors') {
            // Out of zone — show error in badge area, keep form visible
            currentZone = null;
            THRESHOLD = 10000;
            if (msgEl) {
                msgEl.textContent = '⚠ Hors zone';
                msgEl.style.color = '#FF5757';
                msgEl.style.background = 'rgba(255,87,87,0.1)';
                msgEl.style.borderColor = 'rgba(255,87,87,0.2)';
            }
            return;
        }

        currentZone = detection;
        THRESHOLD = detection.zone.threshold;

        // Save to localStorage
        try {
            localStorage.setItem(LS_KEY, JSON.stringify({
                postal: detection.postal,
                zone: detection.key,
                threshold: THRESHOLD
            }));
        } catch (e) {}

        // Sync mobile header pin
        updateHeaderPin(detection.postal);

        if (formEl) formEl.style.display = 'none';
        if (msgEl) {
            msgEl.style.color = '';
            msgEl.style.background = '';
            msgEl.style.borderColor = '';
            msgEl.innerHTML = '';
        }

        // Re-render with updated threshold
        fetchAndRender();

        // Notify cart page bar to re-render with new zone
        document.dispatchEvent(new CustomEvent('dg:zone:changed'));

        // Auto-inject into Ding Doong when user sets/changes zone on cart page
        injectIntoDingDoong(detection.postal);
    }

    /* ── Load from localStorage on init ── */
    function loadSavedZone() {
        try {
            var saved = localStorage.getItem(LS_KEY);
            if (saved) {
                var data = JSON.parse(saved);
                if (data && data.zone && ZONES[data.zone]) {
                    currentZone = { key: data.zone, zone: ZONES[data.zone], postal: data.postal };
                    THRESHOLD = data.threshold || ZONES[data.zone].threshold;
                    return data.postal;
                }
            }
        } catch (e) {}
        return null;
    }

    /* ── Sync mobile header pin ── */
    function updateHeaderPin(postalCode) {
        var pin     = document.getElementById('dg-hdr-postal-pin');
        var codeEl  = document.getElementById('dg-hdr-postal-code');
        if (!pin || !codeEl) return;
        if (postalCode) {
            var formatted = postalCode.substring(0, 3) + '\u00a0' + postalCode.substring(3, 6);
            codeEl.textContent = formatted;
            pin.classList.add('has-zone');
            pin.title = 'Zone : ' + formatted + ' — Tap pour changer';
        } else {
            codeEl.textContent = '—';
            pin.classList.remove('has-zone');
            pin.title = 'Entrer ton code postal';
        }
    }

    /* ── CTA state helpers ── */
    function showCta() {
        var cta = document.getElementById('dg-postal-cta');
        var bar = document.getElementById('dg-fs-bar');
        if (cta) cta.classList.remove('dg-postal-cta--hidden');
        if (bar) {
            bar.classList.remove('dg-fs-bar--visible');
            bar.classList.remove('is-visible');
        }
    }

    function showBar() {
        var cta = document.getElementById('dg-postal-cta');
        var bar = document.getElementById('dg-fs-bar');
        if (cta) cta.classList.add('dg-postal-cta--hidden');
        if (bar) bar.classList.add('dg-fs-bar--visible');
    }

    /* ── Public: open postal input in CTA ── */
    window.dgFsOpenPostalInput = function () {
        var btn  = document.getElementById('dg-postal-cta-btn');
        var form = document.getElementById('dg-postal-cta-form');
        var inp  = document.getElementById('dg-fs-postal-input');
        if (btn)  btn.classList.add('dg-postal-cta__btn--hidden');
        if (form) form.classList.add('dg-postal-cta__form--open');
        if (inp)  { inp.value = ''; setTimeout(function () { inp.focus(); }, 80); }
    };

    /* ── Public: close CTA input (cancel) ── */
    window.dgFsCloseCta = function () {
        var btn  = document.getElementById('dg-postal-cta-btn');
        var form = document.getElementById('dg-postal-cta-form');
        var err  = document.getElementById('dg-postal-cta-error');
        if (btn)  btn.classList.remove('dg-postal-cta__btn--hidden');
        if (form) form.classList.remove('dg-postal-cta__form--open');
        if (err)  { err.textContent = ''; err.classList.remove('is-visible'); }
    };

    /* ── Public: check postal from form submit ── */
    window.dgFsCheckPostal = function (e) {
        if (e) e.preventDefault();
        var inp = document.getElementById('dg-fs-postal-input');
        if (!inp) return;
        var val = inp.value.trim();
        if (!val) return;
        var detection = detectZone(val);

        var err = document.getElementById('dg-postal-cta-error');
        
        if (detection && detection.key === 'invalid_length') {
            if (err) {
                err.textContent = '⚠ Code postal incomplet (6 lettres/chiffres requis)';
                err.classList.add('is-visible');
            }
            return;
        }

        if (detection && detection.key === 'hors') {
            // Show error in CTA
            if (err) {
                err.textContent = '⚠ Code postal hors zone de livraison';
                err.classList.add('is-visible');
            }
            return;
        }

        applyZone(detection);
        showBar();
    };

    /* ── Public: reset postal ── */
    window.dgFsResetPostal = function () {
        currentZone = null;
        THRESHOLD = 10000;
        try { localStorage.removeItem(LS_KEY); } catch (e) {}
        var msgEl = document.getElementById('dg-fs-postal-msg');
        var inp   = document.getElementById('dg-fs-postal-input');
        if (msgEl) { msgEl.innerHTML = ''; }
        if (inp)   { inp.value = ''; }
        updateHeaderPin(null);
        showCta();
        window.dgFsCloseCta();
        fetchAndRender();

        // Notify cart page bar to re-render with new zone
        document.dispatchEvent(new CustomEvent('dg:zone:changed'));
    };

    /* ── Label text (Responsive Desktop/Mobile) ── */
    function labelFromCart(cart) {
        var remaining = THRESHOLD - (cart.total_price || 0);
        var hasItems = (cart.item_count || 0) > 0;
        
        var formattedPostal = currentZone ? currentZone.postal.substring(0, 3) + ' ' + currentZone.postal.substring(3, 6) : '';
        
        // Universal action: " (G9X 1V4) ✎" - compact and elegant for both views
        var postalAction = currentZone ? '&nbsp;&nbsp;<span class="dg-fs-postal-edit" onclick="dgFsResetPostal()" style="padding:2px 8px;">(' + formattedPostal + ') ✎</span>' : '';

        if (!currentZone) {
            // No zone set yet — prompt
            return truckSvg + ' <span class="dg-fs-text-desktop">Entre ton code postal pour voir ta livraison gratuite</span><span class="dg-fs-text-mobile">Vérifie ta livraison gratuite</span>';
        }
        if (!hasItems) {
            return truckSvg + ' <span class="dg-fs-text-desktop">Livraison gratuite d&egrave;s&nbsp;<strong>' + currentZone.zone.label + '</strong></span><span class="dg-fs-text-mobile">Livraison gratuite d&egrave;s&nbsp;<strong>' + currentZone.zone.label + '</strong></span>' + postalAction;
        }
        if (remaining <= 0) {
            return checkSvg + ' <span class="dg-fs-text-desktop"><strong>Livraison gratuite</strong>&nbsp;d&eacute;bloqu&eacute;e</span><span class="dg-fs-text-mobile"><strong>Livraison gratuite !</strong></span>' + postalAction;
        }
        // Mobile text includes "livraison gratuite" but removes "la" to save space
        return truckSvg + ' <span class="dg-fs-text-desktop">Encore&nbsp;<strong>' + fmt(remaining) + '</strong>&nbsp;pour la livraison gratuite</span><span class="dg-fs-text-mobile">Encore&nbsp;<strong>' + fmt(remaining) + '</strong>&nbsp;pour livraison gratuite</span>' + postalAction;
    }

    /* ── Compute pct ── */
    function pctFromCart(cart) {
        return Math.min(((cart.total_price || 0) / THRESHOLD) * 100, 100);
    }

    /* ── Sparkles ── */
    function spawnSparkles(el) {
        if (!el) return;
        var rect = el.getBoundingClientRect();
        for (var i = 0; i < 8; i++) {
            (function (idx) {
                setTimeout(function () {
                    var p = document.createElement('span');
                    p.className = 'dg-fs-sparkle';
                    p.style.left = (rect.left + Math.random() * rect.width) + 'px';
                    p.style.top = (rect.top + Math.random() * rect.height) + 'px';
                    p.style.setProperty('--dx', (Math.random() * 40 - 20) + 'px');
                    p.style.setProperty('--dy', (Math.random() * -40 - 10) + 'px');
                    document.body.appendChild(p);
                    setTimeout(function () { p.remove(); }, 700);
                }, idx * 60);
            })(i);
        }
    }

    /* ── Confetti ── */
    function confettiBurst(el) {
        var colors = ['#4DA3FF', '#7dd3fc', '#34d399', '#fbbf24', '#f472b6', '#a78bfa', '#fb923c'];
        var rect = el ? el.getBoundingClientRect() : null;
        if (!rect) return;
        var cx = rect.left + rect.width / 2;
        var cy = rect.top;
        for (var i = 0; i < 28; i++) {
            (function (idx) {
                setTimeout(function () {
                    var p = document.createElement('span');
                    p.className = 'dg-fs-sparkle dg-fs-confetti';
                    var color = colors[idx % colors.length];
                    p.style.background = color;
                    p.style.boxShadow = '0 0 6px ' + color;
                    p.style.width = (Math.random() * 5 + 4) + 'px';
                    p.style.height = (Math.random() * 5 + 4) + 'px';
                    p.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';
                    var angle = (idx / 28) * Math.PI * 2;
                    var dist = 60 + Math.random() * 80;
                    p.style.left = (cx + Math.cos(angle) * 10) + 'px';
                    p.style.top = (cy + Math.sin(angle) * 10) + 'px';
                    p.style.setProperty('--dx', (Math.cos(angle) * dist) + 'px');
                    p.style.setProperty('--dy', (Math.sin(angle) * dist - 60) + 'px');
                    document.body.appendChild(p);
                    setTimeout(function () { p.remove(); }, 900);
                }, idx * 35);
            })(i);
        }
    }

    /* ══════════════════════════════════
       RENDER
       ══════════════════════════════════ */
    function render(cart, isUpdate) {
        var pct = pctFromCart(cart);
        var hasItems = (cart.item_count || 0) > 0;
        var increased = pct > prevPct;
        prevPct = pct;

        var barEl = document.getElementById('dg-fs-bar');
        var fillEl = document.getElementById('dg-fs-bar-fill');
        var lblEl = document.getElementById('dg-fs-bar-label');
        var truckEl = document.getElementById('dg-fs-truck');

        if (barEl && currentZone) barEl.classList.add('is-visible');
        if (fillEl) fillEl.style.width = (hasItems && currentZone ? pct : 0) + '%';
        if (lblEl) lblEl.innerHTML = labelFromCart(cart);

        /* Position the truck at the fill edge */
        if (truckEl) {
            var showTruck = hasItems && currentZone && pct > 0;
            truckEl.style.opacity = showTruck ? '1' : '0';
            truckEl.style.left = (hasItems && currentZone ? pct : 0) + '%';
        }

        /* Cart button pulse */
        var cartBtn = document.getElementById('dg-topbar-cart-btn');
        if (cartBtn) cartBtn.classList.toggle('has-items', hasItems);

        /* Free/not-free state */
        if (barEl) {
            if (pct >= 100 && currentZone) {
                barEl.classList.add('dg-fs-bar--free');
            } else {
                barEl.classList.remove('dg-fs-bar--free');
            }
        }

        /* Sparkles on increase */
        if (isUpdate && increased && pct < 100 && currentZone) {
            spawnSparkles(fillEl);
        }

        /* Free unlock celebration (once) */
        if (pct >= 100 && currentZone && !hasCelebratedFree) {
            hasCelebratedFree = true;
            confettiBurst(barEl);
            if (barEl) {
                barEl.classList.remove('dg-fs-bar--pulse');
                void barEl.offsetWidth;
                barEl.classList.add('dg-fs-bar--pulse');
                setTimeout(function () { barEl.classList.remove('dg-fs-bar--pulse'); }, 2400);
            }
        } else if (pct < 100) {
            hasCelebratedFree = false;
        }
    }

    /* ── Fetch cart and render ── */
    function fetchAndRender() {
        fetch(ROOT + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                window.DG_cartItems = cart.items || [];
                render(cart, false);
            })
            .catch(function () {});
    }

    /* ── Listen to cart updates ── */
    document.addEventListener('dg:cart:updated', function (e) {
        var cart = e.detail && e.detail.cart;
        if (cart) render(cart, true);
    });

    /* ── Auto-inject postal code into Ding Doong on cart page ── */
    function injectIntoDingDoong(postalCode) {
        if (!postalCode) return;
        // Only run on the cart page
        if (window.location.pathname.indexOf('/cart') === -1) return;

        /* React-compatible value setter — required for Ding Doong's internal state */
        function setNativeValue(input, value) {
            var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
            if (setter && setter.set) {
                setter.set.call(input, value);
            } else {
                input.value = value;
            }
            input.dispatchEvent(new Event('input',  { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        /* Find the postal input inside any known Ding Doong root */
        function findDDInput() {
            var roots = [
                document.getElementById('dingdoong-embedded-render-root'),
                document.getElementById('ot-dingdoong-main'),
                document.getElementById('dingdoong-embedded-root')
            ];
            for (var r = 0; r < roots.length; r++) {
                if (!roots[r]) continue;
                var inp = roots[r].querySelector(
                    'input[type="text"], input[type="search"], input:not([type])'
                );
                if (inp) return inp;
            }
            // Broader fallback
            return document.querySelector(
                '.dingdoong-zipcode-form input[type="text"],' +
                '[class*="dingdoong"] input[type="text"],' +
                '[id*="dingdoong"] input[type="text"],' +
                '.dd-zipcode-input'
            );
        }

        var attempts = 0;
        var maxAttempts = 30; // ~15 seconds

        function tryInject() {
            attempts++;
            var ddInput = findDDInput();

            if (ddInput) {
                var currentVal = (ddInput.value || '').replace(/\s/g, '').toUpperCase();
                var targetVal  = postalCode.replace(/\s/g, '').toUpperCase();
                if (currentVal === targetVal) return; // already correct

                // Format with space: "G9X1E4" → "G9X 1E4"
                var formatted = postalCode.length === 6
                    ? postalCode.substring(0, 3) + ' ' + postalCode.substring(3)
                    : postalCode;

                setNativeValue(ddInput, formatted);

                // Trigger validation: Enter key + submit button click
                setTimeout(function () {
                    ddInput.dispatchEvent(new KeyboardEvent('keydown', {
                        key: 'Enter', code: 'Enter', keyCode: 13, bubbles: true
                    }));
                    var ddContainer = ddInput.closest('[id*="dingdoong"], [class*="dingdoong"]');
                    if (ddContainer) {
                        var btn = ddContainer.querySelector('button[type="submit"], button:not([type])');
                        if (btn && btn.offsetParent !== null) btn.click();
                    }
                }, 200);
                return; // done
            }

            if (attempts < maxAttempts) {
                setTimeout(tryInject, 500);
            }
        }

        // Start immediately or after DOM ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () { setTimeout(tryInject, 500); });
        } else {
            setTimeout(tryInject, 500);
        }

        // Watch for Ding Doong being dynamically inserted into the DOM
        // Déconnecte l'observer précédent avant d'en créer un nouveau (ex: reset postal)
        if (_ddInjectionObserver) {
            _ddInjectionObserver.disconnect();
            _ddInjectionObserver = null;
        }

        var observer = new MutationObserver(function () {
            var ddEl = document.getElementById('dingdoong-embedded-render-root')
                || document.getElementById('ot-dingdoong-main')
                || document.getElementById('dingdoong-embedded-root');
            if (ddEl) {
                observer.disconnect();
                _ddInjectionObserver = null;
                setTimeout(tryInject, 400);
            }
        });
        _ddInjectionObserver = observer; // track for cleanup
        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () {
            observer.disconnect();
            _ddInjectionObserver = null;
        }, 20000);
    }

    /* ── Init ── */
    function init() {
        /* ── SESSION MANAGEMENT ──────────────────────────────────────────────────
         *  dg_postal_zone (localStorage) is CLEARED on every new browser session.
         *  Exception: logged-in customer with a valid default address postal code
         *  (exposed via window.DG_CUSTOMER_POSTAL from theme.liquid).
         *  Within a session, the postal persists across page navigations.
         * ─────────────────────────────────────────────────────────────────────── */
        var SESSION_KEY = 'dg_session_init';
        if (!sessionStorage.getItem(SESSION_KEY)) {
            if (window.DG_CUSTOMER_POSTAL) {
                // Logged-in customer → detect & set their delivery zone automatically
                var cDetection = detectZone(window.DG_CUSTOMER_POSTAL);
                if (cDetection && cDetection.key !== 'hors') {
                    try {
                        localStorage.setItem(LS_KEY, JSON.stringify({
                            postal:    cDetection.postal,
                            zone:      cDetection.key,
                            threshold: cDetection.zone.threshold
                        }));
                    } catch (e) {}
                } else {
                    // Customer's address is out-of-zone → start fresh
                    try { localStorage.removeItem(LS_KEY); } catch (e) {}
                }
            } else {
                // Anonymous visitor → wipe any stale zone from a previous session
                try { localStorage.removeItem(LS_KEY); } catch (e) {}
            }
            sessionStorage.setItem(SESSION_KEY, '1');
        }

        // Restore the postal zone for this session (customer- or user-set)
        var savedPostal = loadSavedZone();
        if (savedPostal && currentZone) {
            // Has a valid zone — skip CTA, go straight to bar
            var msgEl = document.getElementById('dg-fs-postal-msg');
            if (msgEl) {
                msgEl.innerHTML = '';
            }
            updateHeaderPin(savedPostal);
            showBar();

            // Auto-inject into Ding Doong on cart page
            injectIntoDingDoong(savedPostal);
        } else {
            // No valid zone — show the CTA prompt
            showCta();
        }
        fetchAndRender();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
